<template>
    <div class="mediaMain">
        <loader v-if="mediaLoading"/>
        <h4>Auto-Generated Letters</h4>
        <div>
            <v-client-table :data="mediaGridSpec.tableData" :columns="mediaGridSpec.columns" :options="mediaGridSpec.options">
            <template slot="download" slot-scope="props">
                <div style="text-align: center;">
                    <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.parentId, props.row.filename)"></a>
                </div>
            </template>
            <template slot="delete" slot-scope="props" v-if="isAdmin || isRCReview">
                <div style="text-align: center;">
                    <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteMedia(props.row.mediaId)"></a>
                </div>
            </template>
            </v-client-table>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import mediaService from '../services/mediaService'
import userService from '@/services/userService'
import roleService from '@/services/roleService'
import loader from '../components/Loader.vue'
import { mapState } from 'vuex'

export default {
    components: {
        loader
    },
    name: 'media',
    props: {
        mediaTypeId: { required: true },
        parentId: { required: true },
        loadOnMount: { default: true }
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            serverErrorList: [],
            mediaGridSpec: {
                columns: ['download', 'filename', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        filename: 'Filename',
                        createdDate: 'Created Date',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'createdDate'
                    }
                }
            },
            mediaRefreshIntervalId: null,
            mediaRefreshCount: 0
        }
    },
    computed: {
        componentName: function () {
            return 'MediaLetter ' + this._uid
        },
        isAdmin: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.AdminRoleList)
        },
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isRCReview: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ShpoRcAdministrator, roleService.RoleEnum.ShpoRcApprovingUser])
        }
    },
    created () {
        loggingService.log(this.isDebug, this.componentName, 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName, 'mounted ' + this._uid)
        loggingService.log(this.isDebug, this.componentName, 'mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)

        if (this.isAdmin || this.isRCReview) {
            this.mediaGridSpec.columns.push('delete')
        }

        if (this.loadOnMount) this.loadMedia()
    },
    methods: {
        loadMedia () {
            loggingService.log(this.isDebug, this.componentName, 'loadMedia, mediaTypeId: ' + this.mediaTypeId + ', parentId: ' + this.parentId)

            if (this.mediaTypeId && this.parentId) {
                this.mediaLoading = true

                var handle = this
                mediaService.list(this.$http, this.mediaTypeId, null, this.parentId).then(function (response) {
                    handle.mediaGridSpec.tableData = response.data
                    handle.mediaLoading = false
                })
            }
        },
        deleteMedia (mediaId) {
            if (confirm('Are you sure you want to remove this letter?')) {
                mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                    this.loadMedia()
                })
            }
        },
        refreshMedia () {
            if (this.mediaTypeId && this.parentId) {
                mediaService.list(this.$http, this.mediaTypeId, null, this.parentId).then(response => {
                    this.mediaGridSpec.tableData = response.data
                })
            }
        },
        autoRefreshMedia () {
            this.mediaRefreshIntervalId = setInterval(() => {
                if (this.mediaRefreshCount < 20) {
                    this.refreshMedia()
                    this.mediaRefreshCount++
                } else {
                    clearInterval(this.mediaRefreshIntervalId)
                }
            }, 10000)
        },
        mediaDownloadRow (mediaId, mediaTypeId, parentId, filename) {
            loggingService.log(this.isDebug, 'MediaLetter', 'mediaDownloadRow - mediaId: ' + mediaId + ', mediaTypeId: ' + mediaTypeId + ', parentId: ' + parentId)

            mediaService.get(this.$http, mediaId, mediaTypeId, null, parentId).then(function (response) {
                mediaService.saveFileToDownload(response, filename)
            })
        }
    }
}
</script>



<style>
    .mediaMain {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 5px;
        background-color: #FFFFFF;
    }
</style>



// WEBPACK FOOTER //
// MediaLetter.vue?b6089f64